export enum BasketTypeEnum {
  ProcurementBasket,
  ShoppingList,
  OrderGuide
}
